import TimePicker from "@/components/DateTimePicker/timePicker.component";
import { Button } from "@/shadcn/components/ui/button";
import { Calendar } from "@/shadcn/components/ui/calendar";
import React, { useState } from "react";

type CalendarWithTimeProps = {
  dateTime: Date | null | undefined;
  onDateTimeChange: (date: Date | undefined | null) => void;
};

const CalendarWithTime: React.FC<CalendarWithTimeProps> = ({
  dateTime,
  onDateTimeChange,
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    dateTime || null
  );
  const [selectedTime, setSelectedTime] = useState<Date | null>(
    dateTime || null
  );

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleTimeChange = (time: Date | null) => {
    setSelectedTime(time);
  };

  const handleDone = () => {
    if (selectedDate && selectedTime) {
      const updatedDateTime = new Date(selectedDate);
      updatedDateTime.setHours(selectedTime.getHours());
      updatedDateTime.setMinutes(selectedTime.getMinutes());
      updatedDateTime.setSeconds(selectedTime.getSeconds());
      onDateTimeChange(updatedDateTime);
    } else {
      onDateTimeChange(selectedDate);
    }
  };

  return (
    <div>
      <Calendar
        mode="single"
        selected={selectedDate ? new Date(selectedDate) : undefined}
        onSelect={(date) => {
          handleDateChange(date || null);
        }}
        autoFocus
        weekStartsOn={1}
      />
      <TimePicker selected={selectedTime} onChange={handleTimeChange} />
      <div className="flex justify-end p-2">
        <Button onClick={handleDone} className="mt-2">
          Done
        </Button>
      </div>
    </div>
  );
};

export default CalendarWithTime;
